export { default as Spinner } from './Spinner';
export type { SpinnerProps } from './types';
